<template>
  <div>
    <h4 class="title">
      {{ $t('myCabinetMenu.sorular') }}
    </h4>
    <div class="card">
      <div class="card-body">
        <template v-for="(sector,i) in sectors">
          <hr
            v-if="i>0"
            :key="i"
          >

          <router-link
            :key="i"
            class="sector-item"
            :class="{'disabled-sector': !sector.enabled && profile !== 'PROCUREMENT'}"
            :to="{name: 'sector', params:{sectorId: sector.id}}"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div
                  v-if="profile === 'PROCUREMENT'"
                  class="text-truncate"
                >
                  <img
                    :src="getPhoto(sector.icon,'')"
                    :alt="sector.name"
                    class="icon"
                  >
                  <span class="name"> {{ sector.name }} </span>
                </div>
                <div v-else>
                  <img
                    v-if="sector.enabled"
                    :src="getPhoto(sector.icon,'')"
                    :alt="sector.name"
                    class="icon"
                  >
                  <img
                    v-else
                    src="@/assets/images/icons/lock.png"
                    :alt="sector.name"
                    class="icon"
                  >
                  <span class="name"> {{ sector.name }} </span>
                </div>
              </div>
              <div>
                <div
                  v-if="sector.unreadCount>0 && sector.enabled"
                  class="badge bg-success"
                >
                  {{ sector.unreadCount }}
                </div>
                <div
                  v-else-if="sector.requestCount>0"
                  class="badge badge-light"
                >
                  {{ sector.requestCount }}
                </div>
              </div>
            </div>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {getPhoto} from "@/repositories/Utils";

export default {
  name: 'NormalDashboard',
  props: {
    profile: {},
    sectors: {}
  },
  methods: {

    getPhoto(path, size) {
      return getPhoto(path, size);
    },
  }
}
</script>
<style scoped lang="scss">

@import "@/assets/scss/theme/_variables.scss";

.title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 1rem;
}

hr {
  margin: 5px 0;
}

.sector-item {
  display: block;
  cursor: pointer;
  padding: 5px;
  font-size: 15px;
  color: $theme-font-color;
  border-radius: 6px;


  &.disabled-sector {

    .icon {
      background-color: rgba(#E89919, 0.1);
    }

    &:hover {
      background-color: rgba(#E89919, 0.1);
    }

  }

  .icon {
    width: 34px;
    padding: 5px;
    background-color: rgba(#2062FB, 0.05);
    border-radius: 10px;
    margin-right: 10px;
  }

  &:hover {
    padding-left: 5px;
    background-color: rgba(#2062FB, 0.05);

    .icon {
      background: transparent;
    }
  }

}


</style>